import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { DatePipe } from "@angular/common";
import { AppComponent } from "src/app/app.component";
import { Agency, Company, PartnerFromPolicy } from "src/app/types";
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { distinctUntilChanged, startWith, Subscription } from "rxjs";

interface City {
  id: number;
  Nombre: string;
  x_long: number;
  y_lat: number;
  zip_codes: string[];
}

interface ClientDetails {
  nombreCompleto?: string;
  numeroProductor?: string;
  email?: string;
  celular?: string;
  otroTelefono?: string;
  direccion1?: string;
  direccion2?: string;
  ciudad?: string;
  estado?: string;
  codigoPostal?: string;
  /** ISO datetime from validateClient; calendar date is used for effectiveDate */
  efectividad?: string;
}
@Component({
  selector: "app-create-contract",
  templateUrl: "./create-contract.component.html",
  styleUrls: ["./create-contract.component.scss"],
})

export class CreateContractComponent implements OnInit {
  pdfDoc: any;
  form: any;

  pdfSrc = "./assets/contrato-cc.pdf?v=1";

      //   this.lessThan20DisplayData.pagoMensualLessThan20 = splitPayments;
      // // formcontrolname="qAnnualPercent"
      // this.lessThan20DisplayData.porcientoDeInteresLessThan20 = this.quoteData.aprLessThan20;
      // // Pago mensual + diff va en Pago mensual: this.quoteData.splitPayments + diff
      // // Porciento de Interés Anual, formcontrolname="qAnnualPercent" = interest
      // this.lessThan20DisplayData.lessThan20APR = this.quoteData.apr
  lessThan20DisplayData = {
    pagoMensualLessThan20: 0, // formcontrolname="qInstallmentAmount"
    porcientoDeInteresLessThan20: 0, // formcontrolname="qAnnualPercent"
    lessThan20APR: 0, // formcontrolname="qAnnualPercent"
    lessThan20Total: 0 // formcontrolname="qTotalPayment"
  }

  public contract: FormGroup = this._fb.group({
    idProducer: [null], //from local storage
    compulsoryIns: [null],
    // codigo: [null, [Validators.required]],
    agencyId: [null], //added
    insCompany: [""], //added
    invoice: [""], //added
    effectiveDate: ["", [Validators.required]],
    qDateEffective: [""], //from quote
    dateExp: ["", [Validators.required]], //calculate los plazos+ (done)
    qPremium: [null, [Validators.required]], //from quote
    qDownPayment: [null, [Validators.required]], //from quote
    qFinancingAmount: [null, [Validators.required]], //from quote
    qAnnualPercent: [null, [Validators.required]], //from quote
    qInterestPay: [null, [Validators.required]], //from quote
    qTotalPayment: [null, [Validators.required]], //from quote
    totalSalePrice: [null, [Validators.required]], //from quote -calculated
    qInstallments: [null, [Validators.required]], //from quote
    qInstallmentAmount: [null, [Validators.required]], //from quote
    dateFirstPay: ["", [Validators.required]], //input --
    dateLastPay: [{ value: "", disabled: true }], //input --
    dateDomPay: [null, [Validators.required]], //calculate -- dia del primer pago dd
    insName: ["", [Validators.required]],
    insCellphone: ["", []],
    insOtherphone: [""],
    insEmail: ["", [Validators.email]],
    physicalAddress1: ["", [Validators.required]],
    physicalAddress2: [""],
    physicalCity: ["", [Validators.required]],
    physicalState: ["", [Validators.required]],
    physicalZip: ["", [Validators.required]],
    postalAddress1: [""],
    postalAddress2: [""],
    postalCity: [""],
    postalState: [""],
    postalZip: [""],
    policyPrefix: ["", [Validators.required]], //pape-20001 inout
    policyNumber: ["", [Validators.required]],
    contractDate: ["", [Validators.required]], //calculated  (done)
    prodPercent: [null],
    prodCommission: [null],
    createdBy: [null],
    typePolicy: [""],
    active: 1,
    notes: [""],
    stateCode: ["PR"],
    policiesJson: [""],
    quarterlyPayments: [""],
    multiplePolicies: [""],
    contractType: ["", Validators.required],
    lessThan20: [null],
    interesLessThan20: [null],
    aprLessThan20: [null]

  }, { validators: atLeastOnePhoneValidator() });
  public myForm: FormGroup;
  public inputList: Input[] = [];
  private previousCompany: any = null;
  quoteData: any;
  companies: Company[] = [];
  selectedCompany: Company | undefined;
  selectedProducer: any;
  branches: any;
  selectedBranch: any;
  showPostalAddress = false;
  showMsg = false;
  msg: any;
  producers: any;
  userRole: string | null;
  showCompulsoryIns = false;
  originalFinancingAmount: any;
  samePostalAddress: any;
  editData: any;
  addressSame: boolean;
  isMultiplePolicies: boolean;
  agencies: Agency[] = [];
  policiesJson: any = { policies: {} };
  showMultiPolicies = false;
  primaValue: any;
  myRadio: "si" | "no" = "no";
  policyLoading: boolean = false;
  policyUpdated: boolean = false;
  policyFound: PartnerFromPolicy | undefined;
  pronto: number = 0;
  effectiveDateSelected: any;
  prefixOptions: any = [];
  allPrefixOptions: any = [];
  loading = false;
  emailFormatError = false
  private readonly usviPrefixNames = ['000', 'FHO', 'APU', 'DPF'];
  private readonly blockedPrefixes = ['FHO', 'APU', 'DPF'];

  policyWarning: boolean = false;

  // For non-USVI companies: controls form visibility until a policy is found
  policySearched: boolean = false;
  formRevealed: boolean = false;
  policyNotFoundMessage: string = '';

  sucAgency: string | null = null

  stateCodes = [
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'VI', name: 'US Virgin Islands' },
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
  ];

  cityList: City[] = [];
  physicalZipOptions: string[] = [];
  postalZipOptions: string[] = [];
  physicalZipReadonly = false;
  postalZipReadonly = false;

  // City autocomplete
  filteredCities: City[] = [];
  showCityDropdown = false;

  constructor(
    private appComp: AppComponent,
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService
  ) {
    this.myForm = this._fb.group({});

    this.route.queryParams.subscribe((params) => {
      console.log("params:", params);
      try {
        if (this.router.getCurrentNavigation()!.extras.state) {
          let data: any = this.router.getCurrentNavigation()!.extras.state;
          console.log("data:", data);
          this.quoteData = data.data;
          console.log('🔥📣 this.quoteData', this.quoteData, '🔥📣');
        } else {
          this.router.navigate(["/quotation"]);
        }
      } catch (error) {
        console.log("🚨 ERROR", error, "🚨");
        this.router.navigate(["/quotation"]);
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.userRole = "1";
    this.authService.getUsers().then(
      (res: any) => {
        this.producers = res;
        if (this.editData) {
          // if editing contract
          this.selectedProducer = this.producers.filter(
            (p: any) => p.id == this.editData.idProducer
          )[0];
        }
      },
      (err) => {
        console.log(err);
      }
    );

    let dataStore = this.authService.getDataStore();

    // Populating prefix options
    try {
      const prefixOptions = (await this.authService.getPolicySufix()) as any[];
      this.setPrefixOptionsSource(prefixOptions[0]);
    } catch (error) {
      console.log('🚨 ERROR', error, '🚨');
    }

    this.contract.valueChanges.subscribe(async (newValue) => {
      if (!this.quoteData) this.router.navigate(["/quotation"]);
      const effectiveDate = newValue.effectiveDate as Date | undefined

      if (
        effectiveDate &&
        effectiveDate !== this.effectiveDateSelected
      ) {
        console.log("Effective Date changed to:", effectiveDate);
        try {

          this.effectiveDateSelected = effectiveDate;
          const year = effectiveDate.getFullYear()
          const month = effectiveDate.getMonth()
          const day = effectiveDate.getDay()
          const date = new Date(year, month, day);
          let dateExp = new Date(new Date(date).setMonth(date.getMonth() + 12));
          dateExp.setDate(dateExp.getDate() + 1);
          let datePipe = new DatePipe("en-US");

          const dateFirstPay = this.getClosestEffectiveDate(effectiveDate);

          if (effectiveDate > new Date(new Date().setDate(new Date().getDate() + 30))) {
            alert("Incluye el plazo junto con el contrato.")
          }

          const today = new Date();
          const maxFutureDate = new Date(today);
          maxFutureDate.setDate(today.getDate() + 90);
          const minPastDate = new Date(today);
          minPastDate.setDate(today.getDate() - 90);

          if (effectiveDate > maxFutureDate || effectiveDate < minPastDate) {
            alert("La fecha efectiva debe estar entre 90 días hacia atras o adelante de hoy.");
            this.contract.patchValue({
              effectiveDate: null
            });
            return;
          }

          if (!this.editData) {
            this.contract.patchValue({
              dateFirstPay,
            });
            this.updateDomPay(dateFirstPay);
          }

          this.contract.patchValue({
            dateExp: datePipe.transform(dateExp, "yyyy-MM-dd"),
            contractDate: datePipe.transform(date, "yyyy-MM-dd"),
          });
        } catch (error) {
          console.log("❌ ERROR", error, "❌");
        }
      } else if (
        newValue.physicalAddress1 ||
        newValue.physicalAddress2 ||
        newValue.physicalCity ||
        newValue.postalState ||
        newValue.physicalZip
      ) {
        const formValue = this.contract.getRawValue();
        const address2 = formValue.physicalAddress1?.trim() || "";
        const address1 = formValue.physicalAddress2?.trim() || "";
        const city = formValue.physicalCity?.trim() || "";
        const state = formValue.postalState?.trim().toUpperCase() || "";
        const rawZip = formValue.physicalZip?.replace(/\D/g, "") || "";

        // Ensure ZIP is split into 5+4 format
        const zip1 = rawZip.substring(0, 5);
        const zip2 = rawZip.length > 5 ? rawZip.substring(5, 9) : "";

        const shouldValidate = address2 && city && state && zip1.length === 5;

        if (shouldValidate) {
          const uspsData = {
            address1, // Apt, etc
            address2, // Street
            city,
            state,
            zip1,
            zip2,
          };
          try {
            // const response = await this.authService.fetchDirections(uspsData)
          } catch (error) {
            console.log('🚨 ERROR', error, '🚨');
          }
        }
      } 
    });
    const ctCtrl = this.contract.get('contractType');

    ctCtrl!.valueChanges
      .pipe(startWith(ctCtrl!.value), distinctUntilChanged())
      .subscribe((ct: string) => {
        const contractTypeValue = (ct || '').toUpperCase();
        this.loadPrefixOptionsBy(contractTypeValue);
    });



    try {
      const agencies = (await this.authService.getAgencies()) as any;
      this.agencies = (
        agencies[0] && agencies[0].length ? agencies[0] : agencies
      ) as Agency[];
      const companies = (await this.authService.getCompanies()) as any;
      this.companies = (
        companies[0] && companies[0].length ? companies[0] : companies
      ) as any[];
      console.log('👉👉👉👉👉👉👉 this.agencies', this.agencies, ' 👈👈👈👈👈👈👈');
      // guardian id 2062
    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
    }

    try {
      if (this.editData?.multiplePolicies) {
        this.myRadio = "si";
        this.showMultiPolicies = true;
        this.contract.patchValue({
          multiplePolicies: this.showMultiPolicies,
          
        },{ emitEvent: false });
        this.policiesJson = {
          policies: JSON.parse(this.editData.policiesJson),
        };
      } else {
        this.myRadio = "no";
        this.showMultiPolicies = false;
        this.contract.patchValue({
          multiplePolicies: this.showMultiPolicies,
        },{ emitEvent: false });
      }
    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
    }

    if (this.editData) {
      this.primaValue = this.editData.premium;
      this.pronto = this.editData.downPayment || this.editData.minimalAmmount; //TODO: buscar cuál
    } else if (dataStore) {
      let data = JSON.parse(dataStore);
      this.contract.patchValue(data, { emitEvent: false });
      if (data.multiplePolicies) {
        this.myRadio = "si";
        this.showMultiPolicies = true;
      } else {
        this.myRadio = "no";
        this.showMultiPolicies = false;
      }
      if (data.agencyId && data.insCompany) {
        this.selectedCompany = this.companies.filter(
          (c: any) => c.id == data.agencyId
        )[0];
        console.log(this.selectedCompany);
      }
      this.policiesJson = data.policiesJson;
      this.primaValue = data.primaTotal;
      this.pronto = data.downPayment || data.qDownPayment || data.minimalAmmount;
      if (data.type == "auto_private" || data.type == "auto_comercial") {
        this.showCompulsoryIns = true;
      }
      this.contract.patchValue({
        type: data.type,
      },{ emitEvent: false });
    }

    if (this.quoteData) {
      this.contract.patchValue({
        idProducer: parseInt(this.authService.getUserId() ?? ""),
        producerName: this.authService.getUserFullName(),
        producerPhone: this.authService.getUserTel(),
      },{ emitEvent: false });
      let createdBy = this.authService.getUserId();

      let policies = this.quoteData.policiesJson
        ? JSON.stringify(this.quoteData.policiesJson.policies)
        : "";

      try {
        this.contract.patchValue({
          compulsoryIns: this.quoteData.compulsoryIns,
          qAnnualPercent: parseFloat(this.quoteData.annualPercent),
          qFinancingAmount: this.quoteData.financingAmmount,
          qInterestPay: parseFloat(this.quoteData.interestPay),
          qDownPayment: parseFloat(this.quoteData.downPayment),
          qPremium: this.quoteData.premium,
          qTotalPayment: parseFloat(this.quoteData.totalPayment),
          totalSalePrice:
            parseFloat(this.quoteData.totalPayment) +
            parseFloat(this.quoteData.downPayment),
          qInstallments: parseFloat(this.quoteData.months),
          qInstallmentAmount: parseFloat(this.quoteData.splitPayments),
          policiesJson: policies,
          prodPercent: parseInt(this.quoteData.prodPercent ?? ""),
          multiplePolicies: this.quoteData.multiplePolicies,
          quarterlyPayments: this.quoteData.quarterlyPayments,
          prodCommission:
            parseFloat(this.quoteData.financingAmmount) *
            (parseFloat(this.quoteData.prodPercent) * 0.01),
          createdBy: parseInt(createdBy ?? ""),
          postalState: "PR",
          physicalState: "PR",
          typePolicy: this.quoteData.type,
          lessThan20: this.quoteData.lessThan20,
          interesLessThan20: this.quoteData.interesLessThan20,
          aprLessThan20: typeof this.quoteData.aprLessThan20 === 'string' ? Number(this.quoteData.aprLessThan20) : this.quoteData.aprLessThan20
        },{ emitEvent: false });
      } catch (error) {
        console.log("🚨 ERROR", error, "🚨");
      }
      this.pronto = this.quoteData.downPayment || this.quoteData.qDownPayment || this.quoteData.minimalAmmount; // this.quoteData.downPayment;
      this.sucAgency = localStorage.getItem('suc_agency') || null;
      if (this.sucAgency) {
        this.selectedCompany = this.agencies.find((a:Agency) => a.suc_agency == (this.sucAgency));
        if (this.selectedCompany?.complete_name.toUpperCase().includes('SUCURSAL')) {
          this.selectedBranch = this.findBranchByReference("99");
          console.log('✅ this.selectedBranch', this.selectedBranch, '✅');
          console.log('✅ SUCURSAL', this.selectedBranch, '✅');

          this.prefixOptions = this.prefixOptions.filter((p: any) => {
            const name = (p.name || '').toUpperCase();
            return !this.blockedPrefixes.includes(name);
          });

          const selectedPrefix = this.contract.get('policyPrefix')?.value;

          if (
            selectedPrefix &&
            !this.prefixOptions.some((p: any) => p.id === selectedPrefix.id)
          ) {
            this.contract.patchValue({
              policyPrefix: null,
              policyNumber: ''
            }, { emitEvent: false });
          }
        } else if (this.selectedCompany?.complete_name.toUpperCase().includes('USVI') || this.selectedCompany?.suc_agency === '96' || this.selectedCompany?.suc_agency === '76') {
          this.selectedBranch = this.findBranchByReference("76");
          // Cambiar de Green a qué?
          this.contract.patchValue({
            contractType: 'personal',
            stateCode: 'VI'
          })
          console.log('👁️👄👁️ this.agencies', this.agencies, '👀');
          console.log('✅ USVI', this.selectedBranch, '✅');
          
        }

        // Si no es usvi, quitar prefijos FHO, APU Y DPF 
        // this.selectedBranch =this.companies.find((a:Agency) => a.suc_agency == (sucAgency));
      }
    }

    if (this.quoteData.lessThan20) {
      const interest = typeof this.quoteData.aprLessThan20 === 'string' ? Number(this.quoteData.aprLessThan20) : this.quoteData.aprLessThan20;
      const plazos = typeof this.quoteData.months === 'string' ? Number(this.quoteData.months) : this.quoteData.months;
      const twenty = typeof this.quoteData.interesLessThan20 === 'string' ? Number(this.quoteData.interesLessThan20) : this.quoteData.interesLessThan20;
      const varInteres = typeof this.quoteData.interestPay === 'string' ? Number(this.quoteData.interestPay) : this.quoteData.interestPay;
      const splitPayments = typeof this.quoteData.splitPayments === 'string' ? Number(this.quoteData.splitPayments) : this.quoteData.splitPayments; 

      const diff = ((twenty - varInteres) / plazos).toFixed(2);
      this.lessThan20DisplayData.pagoMensualLessThan20 = (Number(diff) + splitPayments).toFixed(2); // splitPayments;
      this.lessThan20DisplayData.porcientoDeInteresLessThan20 = this.quoteData.aprLessThan20;
      this.lessThan20DisplayData.lessThan20APR = interest
      this.lessThan20DisplayData.lessThan20Total = ((Number(this.lessThan20DisplayData.pagoMensualLessThan20) * plazos))
      console.log('👉👉👉👉👉👉👉 this.lessThan20DisplayData', this.lessThan20DisplayData, ' 👈👈👈👈👈👈👈');
    }

    this.contract.get('policyPrefix')?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(prefix => {});

      this.contract.get('physicalCity')?.valueChanges.subscribe(value => {
        this.onPhysicalCityChange(value);
      });

      this.cityList = this.cities; // uses your function that returns this.cities

      // If you want to prefill from existing contract values (editData or stored data):
      const existingPhysicalCity = this.contract.get('physicalCity')?.value;
      if (existingPhysicalCity) {
        this.applyCityToPhysical(existingPhysicalCity);
      }

    this.originalFinancingAmount = this.quoteData?.financingAmmount;

    this.contract.controls["qPremium"].disable();
    this.contract.controls["compulsoryIns"].disable();
    this.contract.controls["qDownPayment"].disable();
    this.contract.controls["qFinancingAmount"].disable();
    this.contract.controls["qInstallments"].disable();
    this.contract.controls["qInterestPay"].disable();
    this.contract.controls["qTotalPayment"].disable();
    this.contract.controls["qInstallmentAmount"].disable();
    this.contract.controls["qAnnualPercent"].disable();

    if (this.quoteData?.compulsoryIns > 0) {
      this.showCompulsoryIns = true;
    }

    try {
      if(this.isUSVI) {
        this.prefixOptions = this.prefixOptions.filter((p:any) => this.usviPrefixNames.includes(p.name));
        this.allPrefixOptions = this.allPrefixOptions.filter((p:any) => this.usviPrefixNames.includes(p.name));
      }
    } catch (error) {
      console.log('🚨 ERROR', error, '🚨');
    }
    this.setupUppercaseFields();
    this.loading = false;
  }

  /** Resolves branch row from `companies` by API `reference` (e.g. "99" SUCURSAL, "94" USVI). */
  private findBranchByReference(reference: string): Company | undefined {
    return this.companies.find(
      (c) => String(c.reference ?? "").trim() === reference
    );
  }

  private setPrefixOptionsSource(prefixSource: any[]): void {
    this.prefixOptions = [...prefixSource];
    this.allPrefixOptions = [...prefixSource];
  }

  private loadPrefixOptionsBy(contractType: string): void{
    const prefixOptionsData = [...this.allPrefixOptions];
    const filteredPrefixOptionsData = prefixOptionsData.filter(p =>
        (p.type || '').toUpperCase() === contractType
    );

    this.prefixOptions = Array.from(
        new Map(filteredPrefixOptionsData.map((p: any) => [p.name, p])).values()
    );
  }

  private setupUppercaseFields(): void {
    const fields = [
      'insName', 'physicalAddress1', 'physicalAddress2', 'physicalCity',
      'postalState', 'postalAddress1', 'postalAddress2', 'postalCity',
      'physicalState', 'policyNumber'
    ];
    fields.forEach(name => {
      const control = this.contract.get(name);
      control?.valueChanges.subscribe(val => {
        if (val && typeof val === 'string' && val !== val.toUpperCase()) {
          control.setValue(val.toUpperCase(), { emitEvent: false });
        }
      });
    });
  }

  updateProducer() {
    this.contract.patchValue({
      idProducer: this.selectedProducer.id,
      producerName: this.selectedProducer.fullname,
      producerPhone: this.selectedProducer.telephone,
    },{ emitEvent: false });
  }

  updateCompany() {
    if (this.selectedCompany) {
      this.appComp.loading = true;
      console.log(this.selectedCompany);
      this.contract.patchValue({
        agencyId: this.selectedCompany.id,
        insCompany: this.selectedCompany.complete_name,
      },{ emitEvent: false });
      this.appComp.loading = false;
    }
    if (this.selectedCompany?.complete_name.toUpperCase().includes('SUCURSAL')) {
      this.selectedBranch = this.findBranchByReference("99");
    }
  }

  updateBranch() {
    console.log(this.selectedBranch);

    let address = this.selectedBranch.address1;
    if (this.selectedBranch.address1?.length > 1) {
      address += ", " + this.selectedBranch.address2;
    }
    address +=
      ", " +
      this.selectedBranch.city +
      " " +
      this.selectedBranch.state +
      " " +
      this.selectedBranch.zip;

    this.contract.patchValue({
      idBranch: this.selectedBranch.id,
      branchName: this.selectedBranch.name,
      branchAddress: address,
    },{ emitEvent: false });
  }

  sameAddress(value: any) {
    console.log(value.target.value);
    this.samePostalAddress = value.target.value;
    if (value.target.value == "si") {
      this.showPostalAddress = false;
      this.contract.patchValue({
        postalAddress1: this.contract.get("physicalAddress1")!.value,
        postalAddress2: this.contract.get("physicalAddress2")!.value,
        postalCity: this.contract.get("physicalCity")!.value,
        postalState: this.contract.get("postalState")!.value,
        postalZip: this.contract.get("physicalZip")!.value,
      },{ emitEvent: false });
    }
    if (value.target.value == "no") {
      this.showPostalAddress = true;
    }
  }

  updateDomPay(value: any) {
    console.log('👉👉👉👉👉👉👉 value', value, ' 👈👈👈👈👈👈👈');
    const dateString =
      value.target && value.target.value ? value.target.value : value;
    let date: Date = typeof value === "string" ? new Date(dateString) : value;

    let months;
    let dateLastPay;
    if (this.quoteData.quarterlyPayments == true) {
      months = 6;
      dateLastPay = new Date(new Date(date).setMonth(date.getMonth() + months));
    } else {
      months = this.quoteData.months;
      dateLastPay = new Date(
        new Date(date).setMonth(date.getMonth() + (parseInt(months) - 1))
      );
    }
    dateLastPay.setDate(dateLastPay.getDate() + 1);
    let datePipe = new DatePipe("en-US");

    this.contract.patchValue({
      dateDomPay: new Date(dateString).getUTCDate(),
      dateLastPay: datePipe.transform(dateLastPay, "yyyy-MM-dd"),
    },{ emitEvent: false });
  }

  isInvalid(controlName: string): boolean {
    const control = this.contract.get(controlName);
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  async createContract() {
    this.appComp.loading = true;
    this.contract.markAllAsTouched();

    // For non-USVI companies: prevent submission if policy was not found
    if (!this.isUSVI && !this.formRevealed) {
      this.showMsg = true;
      this.msg = 'Debe buscar y encontrar una póliza válida antes de crear el contrato.';
      this.appComp.loading = false;
      return;
    }

    const policyFormControl = this.contract.get('policiesJson') as FormGroup;
    const contractObject = this.contract.getRawValue();
    const policies: any[] = policyFormControl?.value?.policies ?? [];


    // 1. Define required policy fields (labels are what will be shown in the msg)
    const requiredPolicyFields = {
      'Número de póliza': contractObject.policyNumber,
      'Sucursal': this.selectedBranch && this.selectedBranch.id,
      // agrega aquí más campos si los necesitas:
      // 'Otra cosa': contractObject.otherField,
    };

    // 2. Collect missing fields
    const missingPolicyFields = Object.entries(requiredPolicyFields)
      .filter(([_, value]) => !value)
      .map(([label]) => label);

    // 3. hasPoliciesInfo is true only if nothing is missing
    const hasPoliciesInfo = missingPolicyFields.length === 0;

    // 4. Existing validation + include hasPoliciesInfo
    console.log('👁️👄👁️ this.contract', this.contract, '👀');
    if (this.contract.invalid || (!policies.length && !hasPoliciesInfo)) {
      this.showMsg = true;
      this.appComp.loading = false;

      const parts: string[] = [];

      if (this.contract.invalid) {
        parts.push('Verifique y llene la información incompleta.');
      }

      if (!policies.length) {      
        // parts.push('Debe agregar al menos una póliza.');
      }

      const emailErr = this.contract.get('insEmail') as any
      // console.log('👉 emailErr', emailErr, '👈');
      if (emailErr && emailErr.value && emailErr.status === "INVALID") {
        this.emailFormatError = true;
      } else this.emailFormatError = false

      if (!hasPoliciesInfo) {
        // parts.push(`(${missingPolicyFields.join(', ')}).`);
      }

      this.msg = parts.join(' ');
      return;
    }

    if (this.samePostalAddress == "si") {
      this.contract.patchValue({
        postalAddress1: this.contract.get("physicalAddress1")!.value,
        postalAddress2: this.contract.get("physicalAddress2")!.value,
        postalCity: this.contract.get("physicalCity")!.value,
        postalState: this.contract.get("physicalState")!.value,
        postalZip: this.contract.get("physicalZip")!.value,
      },{ emitEvent: false });
    }
    // this.appComp.loading = true;
    this.showMsg = false;
    const contractObj = this.contract.getRawValue();
    if (!this.selectedCompany) return;
    if (this.editData) {
      const updateContact: any = {
        quotation: {
          producerId: Number(this.authService.getUserId()),
          aprSelection: this.editData.aprSelection + "%",
          apr: Number(this.editData.apr),
          premium: this.editData.premium,
          downPayment: Number(this.editData.downPayment),
          downPaymentPercentage: Number(this.editData.interestPay),
          monthsSelection: this.editData.months + " months",
          months: Number(this.editData.months),
          companyId: 1, //this.selectedBranch.id,
          status: "confirmed",
          lessThan20: this.editData.lessThan20,
          interesLessThan20: this.quoteData.interesLessThan20,
          aprLessThan20: this.editData.aprLessThan20
        },
        contract: {
          agencyId: this.selectedCompany!.id,
          contractType: contractObj.contractType,
          formalizationDate: this.formatDate(contractObj.dateFirstPay),
          producerId: Number(this.authService.getUserId()),
          customerId: 0,
        },
        policies: [],
      };
      if (!this.policyFound) {
        updateContact.clientPartner = {
          name: contractObj.insName,
          street: contractObj.physicalAddress1,
          street2: contractObj.physicalAddress2,
          city: contractObj.physicalCity,
          stateId: 0,
          zip: contractObj.physicalZip,
          phone: contractObj.insOtherphone
            .replaceAll(" ", "")
            .replaceAll("-", "")
            .replaceAll("(", "")
            .replaceAll(")", ""),
          mobile: contractObj.insCellphone
            .replaceAll(" ", "")
            .replaceAll("-", "")
            .replaceAll("(", "")
            .replaceAll(")", ""),
          email: contractObj.insEmail,
          partner_type: "client", //this.selectedCompany.partner_type,
          refValue: contractObj.policy,
        };
      } else updateContact.contract.customerId = this.policyFound.id;
      if (contractObj.policiesJson && contractObj.policiesJson.length) {
        const policies =
          typeof contractObj.policiesJson === "string"
            ? JSON.parse(contractObj.policiesJson)
            : contractObj.policiesJson;
        policies.forEach((policy: any) => {
          updateContact.policies.push({
            agencyId: Number(policy.branch),
            policyNumber: policy.policyNumber,
            prefix: policy.policyPrefix.name,
            prefixId: policy.policyPrefix.id,
            downPayment: this.editData.downPayment / policies.length, // TODO: dividido por cantidadDePolicies,
            premium: this.editData.premium,
            effectiveDate: this.formatDate(this.editData.effectiveDate),
            expirationDate: this.formatDate(contractObj.dateLastPay),
            // refValue: policies.policyNumber.name + "-" + policies.policyPrefix,
          });
        });
      } else
        updateContact.policies.push({
          agencyId: this.selectedCompany!.id, // o agencyId
          policyNumber: contractObj.policyPrefix,
          id: contractObj.policyNumber.id,
          prefix: contractObj.policyNumber.name,
          downPayment: this.editData.downPayment,
          premium: this.editData.premium,
          stateCode: contractObj.stateCode,
          effectiveDate: this.formatDate(this.editData.effectiveDate),
          expirationDate: this.formatDate(contractObj.dateLastPay),
          refValue:
            contractObj.policyNumber.name + "-" + contractObj.policyPrefix,
        });
      try {
        const response = await this.authService.postFullContract({
          data: updateContact,
          id: this.editData.id,
        });
        console.log("✅ response", response, "✅");
        this.appComp.loading = false;
        this.router.navigateByUrl("/contracts");
      } catch (error) {
        console.log("🚨 ERROR", error, "🚨");
        this.appComp.loading = false;
        this.showMsg = true;
        this.msg = "Ocurrió un error, favor de llenar la información completa.";
      }
    } else {
      const contactCreate: any = {
        quotation: {
          producerId: Number(this.authService.getUserId()),
          aprSelection: this.quoteData.aprSelection + "%",
          apr: Number(this.quoteData.apr),
          premium: this.quoteData.premium,
          downPayment: Number(this.quoteData.downPayment),
          downPaymentPercentage: Number(this.quoteData.interestPay),
          monthsSelection: this.quoteData.months + " months",
          months: Number(this.quoteData.months),
          companyId: 1, //this.selectedBranch.id, TODO:
          status: "confirmed",
          lessThan20: this.quoteData.lessThan20,
          interesLessThan20: this.quoteData.interesLessThan20,
          aprLessThan20: this.quoteData.aprLessThan20
        },
        contract: {
          agencyId: this.selectedCompany!.id,
          contractType: contractObj.contractType,
          formalizationDate: this.formatDate(contractObj.dateFirstPay),
          producerId: Number(this.authService.getUserId()),
          customerId: 0,
          status: 'pending'
        },
        policies: [],
      };
      if (!this.policyFound) {
        contactCreate.clientPartner = {
          name: contractObj.insName,
          street: contractObj.physicalAddress1,
          street2: contractObj.physicalAddress2,
          city: contractObj.physicalCity,
          stateId: 0,
          zip: contractObj.physicalZip,
          stateCode: contractObj.stateCode,
          phone: contractObj.insOtherphone
            .replaceAll(" ", "")
            .replaceAll("-", "")
            .replaceAll("(", "")
            .replaceAll(")", ""),
          mobile: contractObj.insCellphone
            .replaceAll(" ", "")
            .replaceAll("-", "")
            .replaceAll("(", "")
            .replaceAll(")", ""),
          email: contractObj.insEmail,
          partner_type: "client", //this.selectedCompany.partner_type,
          refValue:
            contractObj.policyPrefix.name + "-" + contractObj.policyNumber,
        };
      } else contactCreate.contract.customerId = this.policyFound.id;
      const group = this.contract.get('policiesJson') as FormGroup;
      const policies: any[] = group?.value?.policies ?? [];
      console.log('✅ policies', policies, '✅');
      if (policies && policies.length) {
        policies.forEach((policy: any) => {
          contactCreate.policies.push({
            // id: contractObj.policyPrefix.id,
            // agencyId: Number(),
            companyId: policy.branch, // 186,
            policyNumber: policy.policyNumber,
            contractType: policy.contractType,
            prefixId: policy.policyPrefix.id,
            downPayment: policy.pronto,
            premium: policy.amount,
            effectiveDate: this.formatDate(contractObj.effectiveDate),
            expirationDate: this.formatDate(contractObj.dateLastPay),
            refValue: policy.policyPrefix.name + "-" + policy.policyNumber,
          });
        });
      } else
        contactCreate.policies.push({
          // id: contractObj.policyPrefix.id,
          agencyId: this.selectedCompany!.id, // o agencyId
          policyNumber: contractObj.policyNumber,
          prefixId: contractObj.policyPrefix.id,
          companyId: this.selectedBranch.id,
          // prefix: contractObj.policyPrefix.name,
          invoiceNumber: contractObj.invoice,
          downPayment: this.quoteData.downPayment,
          premium: this.quoteData.premium,
          effectiveDate: this.formatDate(contractObj.effectiveDate),
          expirationDate: this.formatDate(contractObj.dateLastPay),
          contractType: contractObj.contractType,
          refValue:
            contractObj.policyPrefix.name + "-" + contractObj.policyNumber,
        });
      console.log("🔥📣 contractObj", contractObj, "🔥📣");
      console.log("✅ contactCreate", contactCreate, "✅");
      try {
        const response = await this.authService.postFullContract({
          data: contactCreate,
        });
        console.log("🔥📣 response", response, "🔥📣");
        this.appComp.loading = false;
        this.router.navigateByUrl("/contracts");
      } catch (error) {
        this.appComp.loading = false;
        console.log("🚨 ERROR", error, "🚨");
        this.showMsg = true;
        this.msg = "Ocurrió un error, verifique los campos e intente de nuevo.";
      }
    }
  }

canCreate = true; // field on the component

private recomputeCanCreate() {
  if (this.myRadio !== 'si') { this.canCreate = true; return; }

  const prima = Number(this.contract.get('qPremium')?.value) || 0;
  const pronto = Number(this.contract.get('qDownPayment')?.value) || 0;
  // If you kept the child FormGroup under 'policiesJson':
  const group = this.contract.get('policiesJson') as FormGroup;
  const policies: any[] = group?.value?.policies ?? [];

  if (!Array.isArray(policies) || policies.length === 0) { this.canCreate = false; return; }

  let amountInput = 0, prontoInput = 0;
  for (const p of policies) {
    amountInput += Number(p.amount);
    prontoInput += Number(p.pronto);
  }
  this.canCreate = (prima - amountInput === 0) && (pronto - prontoInput === 0);
}




  updatePhysicalState() {
    console.log(this.contract.controls["physicalState"].value.toUpperCase());
    this.contract.patchValue({
      physicalState:
        this.contract.controls["physicalState"].value.toUpperCase(),
    },{ emitEvent: false });
  }

  updatePostalState() {
    console.log(this.contract.controls["postalState"].value.toUpperCase());
    this.contract.patchValue({
      postalState: this.contract.controls["postalState"].value.toUpperCase(),
    },{ emitEvent: false });
  }

  private polSub?: Subscription;

  addChildForm(name: string, group: FormGroup) {
      if (!this.contract.get(name)) this.contract.addControl(name, group);
  else this.contract.setControl(name, group);
    // add control once; don’t keep re-adding it
    if (!this.contract.get(name)) {
      this.contract.addControl(name, group);
    } else {
      this.contract.setControl(name, group);
    }

    // If you must mirror the array into the parent, do it silently:
    this.contract.patchValue(
      { policiesJson: group.value.policies },
      { emitEvent: false }
    );

      this.polSub?.unsubscribe();
  this.polSub = group.valueChanges.subscribe(() => this.recomputeCanCreate());

  // compute once with initial values
  this.recomputeCanCreate();

  }

  checkMultiPolicy(event: any) {
    this.showMultiPolicies = event.target.value === "si";
    this.contract.patchValue({ multiplePolicies: this.showMultiPolicies }, { emitEvent: false });

    if (!this.showMultiPolicies) {
      // remove the child FormGroup entirely
      this.contract.removeControl('policiesJson', { emitEvent: false });
    }
    this.recomputeCanCreate();
    }

  async findPolicy() {
    const contract = this.contract.getRawValue();
    const prefixName = this.prefixOptions.find(
      (p: any) => p.id === contract.policyPrefix.id
    );
    if (!prefixName) return;
    const eventTarget = prefixName.name + "-" + contract.policyNumber;
    this.policyLoading = true;
    this.policySearched = true;
    if (eventTarget) {
      this.policyUpdated = false;
      try {
        const res = (await this.authService.getClientDetailsFromPolicyID(
          eventTarget
        )) as ClientDetails;
        // Since getClientDetailsFromPolicyID doesn't return the same shape, clear policyFound
        this.policyFound = undefined;

        // Check if response has usable data (at least name or email or phone)
        const hasUsableData = !!(res.nombreCompleto || res.email || res.celular);

        if (hasUsableData) {
          // For non-USVI: reveal the form first when policy is found
          if (this.isUSVI) {
            this.formRevealed = true;
            this.policyNotFoundMessage = '';
          }

          // Safe fallback for address fields
          const d1 = (res.direccion1 ?? '').trim();
          const d2 = (res.direccion2 ?? '').trim();
          const physicalAddress1 = d1 || d2 || '';
          const physicalAddress2 = (d1 && d2) ? d2 : '';

          const partnerObj = {
            insName: res.nombreCompleto || '',
            insEmail: res.email || '',
            insCellphone: res.celular || '',
            insOtherphone: res.otroTelefono || '',
            physicalAddress1,
            physicalAddress2,
            physicalCity: res.ciudad || '',
            physicalState: res.estado || 'PR',
            physicalZip: res.codigoPostal || '',
          };
          this.contract.patchValue(partnerObj, { emitEvent: false });
          const efectividadRaw = res.efectividad?.trim();
          if (efectividadRaw) {
            const effective = new Date(efectividadRaw);
            if (!isNaN(effective.getTime())) {
              this.contract.patchValue(
                { effectiveDate: effective },
                { emitEvent: true }
              );
            }
          }
          this.formRevealed = true;
          this.policyNotFoundMessage = '';
          this.policyUpdated = true;
        } else {
          // For non-USVI: hide the form and show message when policy is not found
          if (!this.isUSVI) {
            this.formRevealed = false;
            this.policyNotFoundMessage = 'No se encontró la póliza. Verifique el prefijo y número de póliza e intente nuevamente.';
          }
          this.policyUpdated = false;
        }

        this.policyLoading = false;
      } catch (error) {
        console.log("🚨 ERROR", error, "🚨");
        // For non-USVI: hide the form and show message on error
        if (!this.isUSVI) {
          this.formRevealed = false;
          this.policyNotFoundMessage = 'No se encontró la póliza. Verifique el prefijo y número de póliza e intente nuevamente.';
        }
        this.policyLoading = false;
      }
    }
  }

  addPartner() {
    if (this.policyFound) {
      const partnerObj = {
        insName: this.policyFound.name,
        insEmail: this.policyFound.email,
        insCellphone: this.policyFound.mobile,
        insOtherphone: this.policyFound.phone,
        physicalAddress1: this.policyFound.street,
        physicalAddress2: this.policyFound.street2,
        physicalCity: this.policyFound.city,
        physicalState: this.policyFound.stateName || "PR",
        physicalZip: this.policyFound.zip,
        stateCode: this.policyFound.stateCode,
      };
      this.contract.patchValue(partnerObj,{ emitEvent: false });
      this.policyUpdated = true;
    }
  }

  formatDate(dateString: string) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = "12";
    const minutes = "00";
    const seconds = "00";

    const localIsoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

    return localIsoString;
  }

getClosestEffectiveDate(inputDate: Date): Date {
  const anchorDays = [5, 10, 15, 20, 25, 30];

  // If we land on the 30th, bump to the 1st of the next month
  const normalize = (d: Date) =>
    d.getDate() === 30 ? new Date(d.getFullYear(), d.getMonth() + 1, 1) : d;

  // Step 1: date2 = inputDate + 30 days
  const date2 = new Date(inputDate);
  date2.setDate(date2.getDate() + 30);

  const year = date2.getFullYear();
  const month = date2.getMonth(); // 0-indexed
  const day = date2.getDate();

  // NEW: if 26 or higher, make it the 1st of next month
  if (day >= 26) {
    return new Date(year, month + 1, 1);
  }

  // Step 2: smallest anchor day that is >= day (same month, on/after date2)
  const sameMonthAnchor = anchorDays.find(anchor => anchor >= day);

  if (sameMonthAnchor !== undefined) {
    return normalize(new Date(year, month, sameMonthAnchor));
  }

  // Step 3: no anchor left in this month → take the earliest valid anchor next month
  let nextMonth = month + 1;
  let nextYear = year;
  if (nextMonth > 11) {
    nextMonth = 0;
    nextYear += 1;
  }

  for (const anchor of anchorDays) {
    const candidate = new Date(nextYear, nextMonth, anchor);
    if (candidate.getMonth() === nextMonth) {
      return normalize(candidate);
    }
  }

  return new Date(nextYear, nextMonth + 1, 0);
}


  get policyPrefix() {
    const policyPrefix = this.contract.getRawValue().policyPrefix
    return  policyPrefix ? this.contract.getRawValue().policyPrefix.id : null;
  }

  // Returns true if selected company includes 'USVI' - behavior should not change for USVI
  get isUSVI(): boolean {
    return (
      (this.selectedCompany?.complete_name?.toUpperCase().includes('USVI') || 
      this.selectedCompany?.id === 2062 ||
      this.selectedCompany?.id === 200 ||
      this.selectedCompany?.id === 187) ?? false
    )
  }

  // Returns true if the insured info form should be shown
  get shouldShowInsuredForm(): boolean {
    // If USVI, always show the form (no change in behavior)
    if (this.isUSVI) {
      return true;
    }
    // For non-USVI, only show if a policy has been successfully found
    return this.formRevealed;
  }


  private findCityByName(name?: string): City | undefined {
    console.log('🔍 Searching for city:', name);
    if (!name) return undefined;
    return this.cityList.find(c => c.Nombre?.toLowerCase() === name.trim().toLowerCase());
  }

  onCityInputChange(value: string) {
    // Only filter cities and control dropdown visibility.
    // The form control is already updated by formControlName binding.
    if (!value || value.length < 1) {
      this.filteredCities = [];
      this.showCityDropdown = false;
      return;
    }
    const search = value.toLowerCase();
    this.filteredCities = this.cityList.filter(c => 
      c.Nombre?.toLowerCase().includes(search)
    );
    this.showCityDropdown = this.filteredCities.length > 0;
  }

  selectCity(city: City) {
    // Set the form control value - the valueChanges subscription will trigger onPhysicalCityChange
    this.contract.get('physicalCity')?.setValue(city.Nombre, { emitEvent: true });
    this.showCityDropdown = false;
    this.filteredCities = [];
  }

  hideCityDropdown() {
    // Delay to allow click event to fire first
    setTimeout(() => {
      this.showCityDropdown = false;
    }, 200);
  }

  onPhysicalCityChange(name: string) {
    const city = this.findCityByName(name);
    console.log('🏙️ Selected city:', city);
    if (!city) {
      console.log('❌ City not found, clearing zip options.');
      this.physicalZipOptions = [];
      this.physicalZipReadonly = false;
      this.contract.get('physicalZip')?.setValue('', { emitEvent: false });
      return;
    }

    const zips = city.zip_codes ?? [];
    if (zips.length === 1) {
      console.log('✅ One zip found:', zips[0]);
      // Single zip: set the control value and make it readonly
      this.contract.get('physicalZip')?.setValue(zips[0], { emitEvent: false });
      this.physicalZipOptions = [zips[0]];
      this.physicalZipReadonly = true;
    } else if (zips.length > 1) {
      console.log('✅ Multiple zips found:', zips);
      // Multiple zips: clear the control and allow user to type/select
      this.contract.get('physicalZip')?.setValue('', { emitEvent: false });
      this.physicalZipOptions = [...zips];
      this.physicalZipReadonly = false;
    } else {
      console.log('⚠️ No zips found for this city.');
      this.physicalZipOptions = [];
      this.physicalZipReadonly = false;
      this.contract.get('physicalZip')?.setValue('', { emitEvent: false });
    }
  }

  // small helpers used in ngOnInit to apply existing values when editing
  private applyCityToPhysical(cityName: string) {
    // The form control value is already set; just trigger the zip logic via subscription
    // Use setTimeout to ensure subscription is set up first during initialization
    setTimeout(() => {
      // Re-emit the value to trigger the subscription if it wasn't triggered yet
      const currentValue = this.contract.get('physicalCity')?.value;
      if (currentValue === cityName) {
        // Value already matches, manually trigger the change handler
        this.onPhysicalCityChange(cityName);
      } else {
        this.contract.get('physicalCity')?.setValue(cityName, { emitEvent: true });
      }
    }, 0);
  }

  onPhysicalZipInputChange(value: string) {
    // The form control is already updated by formControlName binding,
    // so we only need to compute the autocomplete options here.

    if (!value) {
      this.physicalZipOptions = [];
      return;
    }

    const allZips = this.cityList
      .flatMap(city => city.zip_codes ?? [])
      .filter(zip => zip.startsWith(value));

    this.physicalZipOptions = allZips;

    if (allZips.length === 1) {
      console.log('✅ One zip matched input:', allZips[0]);
      this.selectPhysicalZip(allZips[0]);
    } else {
      console.log('ℹ️ Multiple or no zips matched input.');
      // Keep user's typed value in the control (do not clear it)
    }
  }

  selectPhysicalZip(zip: string) {
    console.log('🏷️ Zip selected:', zip);
    this.contract.get('physicalZip')?.setValue(zip, { emitEvent: true });
    this.physicalZipOptions = [];
  }
 cities = [
  {
    "id": 0,
    "Nombre": "Adjuntas",
    "x_long": -66.754,
    "y_lat": 18.18,
    "zip_codes": ["00601"]
  },
  {
    "id": 1,
    "Nombre": "Aguada",
    "x_long": -67.175,
    "y_lat": 18.36,
    "zip_codes": ["00602"]
  },
  {
    "id": 2,
    "Nombre": "Aguadilla",
    "x_long": -67.121,
    "y_lat": 18.46,
    "zip_codes": ["00603","00604","00605"]
  },
  {
    "id": 3,
    "Nombre": "Aguas Buenas",
    "x_long": -66.127,
    "y_lat": 18.251,
    "zip_codes": ["00703"]
  },
  {
    "id": 4,
    "Nombre": "Aibonito",
    "x_long": -66.264,
    "y_lat": 18.131,
    "zip_codes": ["00705"]
  },
  {
    "id": 5,
    "Nombre": "Anasco",
    "x_long": -67.12,
    "y_lat": 18.288,
    "zip_codes": ["00610"]
  },
  {
    "id": 6,
    "Nombre": "Arecibo",
    "x_long": -66.675,
    "y_lat": 18.407,
    "zip_codes": ["00612","00613","00614"]
  },
  {
    "id": 7,
    "Nombre": "Arroyo",
    "x_long": -66.056,
    "y_lat": 17.998,
    "zip_codes": ["00714"]
  },
  {
    "id": 8,
    "Nombre": "Barceloneta",
    "x_long": -66.56,
    "y_lat": 18.445,
    "zip_codes": ["00617"]
  },
  {
    "id": 9,
    "Nombre": "Barranquitas",
    "x_long": -66.31,
    "y_lat": 18.202,
    "zip_codes": []
  },
  {
    "id": 10,
    "Nombre": "Bayamon",
    "x_long": -66.168,
    "y_lat": 18.35,
    "zip_codes": []
  },
  {
    "id": 11,
    "Nombre": "Cabo Rojo",
    "x_long": -67.154,
    "y_lat": 18.042,
    "zip_codes": ["00623"]
  },
  {
    "id": 12,
    "Nombre": "Caguas",
    "x_long": -66.051,
    "y_lat": 18.212,
    "zip_codes": ["00720","00725"]
  },
  {
    "id": 13,
    "Nombre": "Camuy",
    "x_long": -66.86,
    "y_lat": 18.419,
    "zip_codes": ["00627"]
  },
  {
    "id": 14,
    "Nombre": "Canovanas",
    "x_long": -65.888,
    "y_lat": 18.329,
    "zip_codes": ["00729"]
  },
  {
    "id": 15,
    "Nombre": "Carolina",
    "x_long": -65.957,
    "y_lat": 18.375,
    "zip_codes": []
  },
  {
    "id": 16,
    "Nombre": "Catano",
    "x_long": -66.144,
    "y_lat": 18.438,
    "zip_codes": []
  },
  {
    "id": 17,
    "Nombre": "Cayey",
    "x_long": -66.149,
    "y_lat": 18.103,
    "zip_codes": ["00736"]
  },
  {
    "id": 18,
    "Nombre": "Ceiba",
    "x_long": -65.667,
    "y_lat": 18.252,
    "zip_codes": ["00735"]
  },
  {
    "id": 19,
    "Nombre": "Ciales",
    "x_long": -66.516,
    "y_lat": 18.289,
    "zip_codes": ["00638"]
  },
  {
    "id": 20,
    "Nombre": "Cidra",
    "x_long": -66.161,
    "y_lat": 18.174,
    "zip_codes": ["00739"]
  },
  {
    "id": 21,
    "Nombre": "Coamo",
    "x_long": -66.36,
    "y_lat": 18.097,
    "zip_codes": []
  },
  {
    "id": 22,
    "Nombre": "Comerio",
    "x_long": -66.222,
    "y_lat": 18.225,
    "zip_codes": ["00782"]
  },
  {
    "id": 23,
    "Nombre": "Corozal",
    "x_long": -66.328,
    "y_lat": 18.304,
    "zip_codes": ["00783"]
  },
  {
    "id": 24,
    "Nombre": "Culebra",
    "x_long": -65.287,
    "y_lat": 18.316,
    "zip_codes": []
  },
  {
    "id": 25,
    "Nombre": "Dorado",
    "x_long": -66.278,
    "y_lat": 18.437,
    "zip_codes": ["00646"]
  },
  {
    "id": 26,
    "Nombre": "Fajardo",
    "x_long": -65.668,
    "y_lat": 18.318,
    "zip_codes": ["00738"]
  },
  {
    "id": 27,
    "Nombre": "Florida",
    "x_long": -66.56,
    "y_lat": 18.373,
    "zip_codes": ["00650"]
  },
  {
    "id": 28,
    "Nombre": "Guanica",
    "x_long": -66.92,
    "y_lat": 17.983,
    "zip_codes": ["00653"]
  },
  {
    "id": 29,
    "Nombre": "Guayama",
    "x_long": -66.134,
    "y_lat": 18.008,
    "zip_codes": []
  },
  {
    "id": 30,
    "Nombre": "Guayanilla",
    "x_long": -66.792,
    "y_lat": 18.041,
    "zip_codes": ["00656"]
  },
  {
    "id": 31,
    "Nombre": "Guaynabo",
    "x_long": -66.114,
    "y_lat": 18.343,
    "zip_codes": []
  },
  {
    "id": 32,
    "Nombre": "Gurabo",
    "x_long": -65.979,
    "y_lat": 18.266,
    "zip_codes": []
  },
  {
    "id": 33,
    "Nombre": "Hatillo",
    "x_long": -66.796,
    "y_lat": 18.411,
    "zip_codes": ["00659"]
  },
  {
    "id": 34,
    "Nombre": "Hormigueros",
    "x_long": -67.114,
    "y_lat": 18.134,
    "zip_codes": ["00660"]
  },
  {
    "id": 35,
    "Nombre": "Humacao",
    "x_long": -65.81,
    "y_lat": 18.145,
    "zip_codes": ["00791"]
  },
  {
    "id": 36,
    "Nombre": "Isabela",
    "x_long": -67.005,
    "y_lat": 18.45,
    "zip_codes": ["00662"]
  },
  {
    "id": 37,
    "Nombre": "Jayuya",
    "x_long": -66.588,
    "y_lat": 18.211,
    "zip_codes": ["00664"]
  },
  {
    "id": 38,
    "Nombre": "Juana Diaz",
    "x_long": -66.495,
    "y_lat": 18.051,
    "zip_codes": []
  },
  {
    "id": 39,
    "Nombre": "Juncos",
    "x_long": -65.909,
    "y_lat": 18.224,
    "zip_codes": ["00777"]
  },
  {
    "id": 40,
    "Nombre": "Lajas",
    "x_long": -67.04,
    "y_lat": 18.012,
    "zip_codes": ["00667"]
  },
  {
    "id": 41,
    "Nombre": "Lares",
    "x_long": -66.867,
    "y_lat": 18.269,
    "zip_codes": ["00669"]
  },
  {
    "id": 42,
    "Nombre": "Las Marias",
    "x_long": -66.983,
    "y_lat": 18.237,
    "zip_codes": ["00670"]
  },
  {
    "id": 43,
    "Nombre": "Las Piedras",
    "x_long": -65.869,
    "y_lat": 18.187,
    "zip_codes": []
  },
  {
    "id": 44,
    "Nombre": "Loiza",
    "x_long": -65.899,
    "y_lat": 18.426,
    "zip_codes": ["00772"]
  },
  {
    "id": 45,
    "Nombre": "Luquillo",
    "x_long": -65.725,
    "y_lat": 18.342,
    "zip_codes": ["00773"]
  },
  {
    "id": 46,
    "Nombre": "Manati",
    "x_long": -66.49,
    "y_lat": 18.42,
    "zip_codes": ["00674"]
  },
  {
    "id": 47,
    "Nombre": "Maricao",
    "x_long": -66.942,
    "y_lat": 18.172,
    "zip_codes": []
  },
  {
    "id": 48,
    "Nombre": "Maunabo",
    "x_long": -65.922,
    "y_lat": 18.018,
    "zip_codes": []
  },
  {
    "id": 49,
    "Nombre": "Mayaguez",
    "x_long": -67.112,
    "y_lat": 18.211,
    "zip_codes": ["00680","00681","00682"]
  },
  {
    "id": 50,
    "Nombre": "Moca",
    "x_long": -67.081,
    "y_lat": 18.378,
    "zip_codes": ["00676"]
  },
  {
    "id": 51,
    "Nombre": "Morovis",
    "x_long": -66.42,
    "y_lat": 18.317,
    "zip_codes": ["00687"]
  },
  {
    "id": 52,
    "Nombre": "Naguabo",
    "x_long": -65.754,
    "y_lat": 18.231,
    "zip_codes": ["00718"]
  },
  {
    "id": 53,
    "Nombre": "Naranjito",
    "x_long": -66.253,
    "y_lat": 18.288,
    "zip_codes": ["00719"]
  },
  {
    "id": 54,
    "Nombre": "Orocovis",
    "x_long": -66.434,
    "y_lat": 18.215,
    "zip_codes": ["00720"]
  },
  {
    "id": 55,
    "Nombre": "Patillas",
    "x_long": -66.013,
    "y_lat": 18.032,
    "zip_codes": ["00723"]
  },
  {
    "id": 56,
    "Nombre": "Penuelas",
    "x_long": -66.721,
    "y_lat": 18.061,
    "zip_codes": ["00624"]
  },
  {
    "id": 57,
    "Nombre": "Ponce",
    "x_long": -66.614,
    "y_lat": 18.06,
    "zip_codes": ["00716","00717","00728","00730","00731","00732","00733","00734"]
  },
  {
    "id": 58,
    "Nombre": "Quebradillas",
    "x_long": -66.926,
    "y_lat": 18.44,
    "zip_codes": ["00678"]
  },
  {
    "id": 59,
    "Nombre": "Rincon",
    "x_long": -67.232,
    "y_lat": 18.335,
    "zip_codes": ["00677"]
  },
  {
    "id": 60,
    "Nombre": "Rio Grande",
    "x_long": -65.814,
    "y_lat": 18.346,
    "zip_codes": []
  },
  {
    "id": 61,
    "Nombre": "Sabana Grande",
    "x_long": -66.944,
    "y_lat": 18.083,
    "zip_codes": ["00637"]
  },
  {
    "id": 62,
    "Nombre": "Salinas",
    "x_long": -66.256,
    "y_lat": 18.011,
    "zip_codes": ["00751"]
  },
  {
    "id": 63,
    "Nombre": "San German",
    "x_long": -67.038,
    "y_lat": 18.111,
    "zip_codes": ["00683"]
  },
  {
    "id": 64,
    "Nombre": "San Juan",
    "x_long": -66.061,
    "y_lat": 18.387,
    "zip_codes": ["00901","00906","00907","00909","00911","00912","00913","00915","00917","00918"]
  },
  {
    "id": 65,
    "Nombre": "San Lorenzo",
    "x_long": -65.976,
    "y_lat": 18.148,
    "zip_codes": ["00754"]
  },
  {
    "id": 66,
    "Nombre": "San Sebastian",
    "x_long": -66.971,
    "y_lat": 18.329,
    "zip_codes": ["00685"]
  },
  {
    "id": 67,
    "Nombre": "Santa Isabel",
    "x_long": -66.389,
    "y_lat": 17.995,
    "zip_codes": ["00757"]
  },
  {
    "id": 68,
    "Nombre": "Toa Alta",
    "x_long": -66.246,
    "y_lat": 18.363,
    "zip_codes": []
  },
  {
    "id": 69,
    "Nombre": "Toa Baja",
    "x_long": -66.214,
    "y_lat": 18.431,
    "zip_codes": []
  },
  {
    "id": 70,
    "Nombre": "Trujillo Alto",
    "x_long": -65.999,
    "y_lat": 18.336,
    "zip_codes": []
  },
  {
    "id": 71,
    "Nombre": "Utuado",
    "x_long": -66.702,
    "y_lat": 18.271,
    "zip_codes": ["00641"]
  },
  {
    "id": 72,
    "Nombre": "Vega Alta",
    "x_long": -66.337,
    "y_lat": 18.409,
    "zip_codes": ["00692"]
  },
  {
    "id": 73,
    "Nombre": "Vega Baja",
    "x_long": -66.398,
    "y_lat": 18.428,
    "zip_codes": ["00693","00694"]
  },
  {
    "id": 74,
    "Nombre": "Vieques",
    "x_long": -65.441,
    "y_lat": 18.123,
    "zip_codes": ["00765"]
  },
  {
    "id": 75,
    "Nombre": "Villalba",
    "x_long": -66.473,
    "y_lat": 18.128,
    "zip_codes": ["00766"]
  },
  {
    "id": 76,
    "Nombre": "Yabucoa",
    "x_long": -65.897,
    "y_lat": 18.071,
    "zip_codes": ["00767"]
  },
  {
    "id": 77,
    "Nombre": "Yauco",
    "x_long": -66.859,
    "y_lat": 18.08,
    "zip_codes": ["00698"]
  }
];

}

export function atLeastOnePhoneValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const cell = group.get('insCellphone')?.value;
    const other = group.get('insOtherphone')?.value;
    if (!cell && !other) {
      return { atLeastOnePhone: true };
    }
    return null;
  };
}

